import OtherWebAPI from '../clientLogic/apis/WebAPI'
import store from '@/store'

const getConfig = function () {
  const headers = {
    'x-api-key': process.env.API_KEY,
    'x-access-token': store.state.auth.token,
    'x-username': store.state.auth.username,
    'Access-Control-Request-Headers': 'text/plain'
  }

  return {
    headers
  }
}

export default class WebAPI extends OtherWebAPI {
  constructor ({baseURL}) {
    super({sessionFunc: getConfig, baseURL})
  }
}



// WEBPACK FOOTER //
// ./src/app/api/WebAPI.js